<template>
  <el-dialog :title="dialogTitle" :visible.sync="open" :center="true" width="80%" @close="cancel"
    :close-on-click-modal="false">
    <el-form>
      <el-row>
        <template v-for="(item, index) in filterOptions">
          <el-col v-if="!item.hidden" :key="index" :span="item.type == 'date' ? 6 : 4">
            <el-form-item :prop="item.code">
              <el-date-picker v-if="item.type == 'date'" :clearable="false" v-model="query[item.code]"
                style="width: 100%" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                @input="(val) => dateChange(val, item)" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>

              <el-input v-if="item.type == 'input'" v-model="query[item.code]" style="width: 100%"
                :placeholder="'请填写' + item.name"></el-input>

              <el-select v-if="item.type == 'select' && !item.multiple" v-model="query[item.code + 'Name']"
                style="width: 100%" :placeholder="'请选择' + item.name" clearable filterable :filter-method="(k) =>
                    selectFilterChange(
                      item.filterMethod ? item.filterMethod : null,
                      k,
                      item
                    )
                  " @change="(val) => selectChange(val, item)">
                <el-option v-for="m in item.data" :key="m.id" :label="item.labelName ? m[item.labelName] : m.name"
                  :value="m.id"></el-option>
              </el-select>

              <el-select v-if="item.type == 'select' && item.multiple" v-model="query[item.code]" style="width: 100%"
                :multiple="item.multiple" :placeholder="'请选择' + item.name" clearable filterable :filter-method="(k) =>
                    selectFilterChange(
                      item.filterMethod ? item.filterMethod : null,
                      k,
                      item
                    )
                  " @change="(val) => selectMultipleChange(val, item)">
                <el-option v-for="m in item.data" :key="m.id" :label="item.labelName ? m[item.labelName] : m.name"
                  :value="m.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </template>
        <el-col :span="8">
          <el-button class="btn primary" size="small" v-preventReClick @click="queryChange">查询</el-button>
          <el-button class="btn default" size="small" v-preventReClick @click="reset">重置</el-button>
          <el-button class="btn primary" size="small" v-preventReClick @click="submit">确认添加</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div style="height: 520px">
      <el-table ref="childTable" v-loading="loading" :row-key="rowKey" border :data="tableData" height="500"
        style="width: auto; margin: 0 10px" @selection-change="handleChildSelectionChange"
        :header-cell-style="{ background: '#DDEBFF' }">
        <el-table-column type="selection" :reserve-selection="true" width="55" align="center"></el-table-column>
        <template v-for="item in columOptions">
          <el-table-column v-if="item.type == 'date'" show-overflow-tooltip :prop="item.key"
            :min-width="item.width || 100" :label="item.label" :key="item.label">
            <template slot-scope="scope">
              {{
                scope.row[item.key]
                  ? parseTime(new Date(scope.row[item.key]), "{y}-{m}-{d}")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column v-else-if="item.type == 'datetime'" show-overflow-tooltip :min-width="item.width || 100"
            :prop="item.key" :label="item.label" :key="item.label">
            <template slot-scope="scope">
              {{ scope.row[item.key] ? parseTime(new Date(scope.row[item.key])) : "" }}
            </template>
          </el-table-column>
          <el-table-column v-else show-overflow-tooltip :prop="item.key" :min-width="item.width || 100"
            :label="item.label" :key="item.label">
            <template slot-scope="scope">
              <span v-html="item.fomtter ? item.fomtter(scope.row) : scope.row[item.key]"></span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10,20, 40, 50, 100]"
        :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total"
        @current-change="changePage">
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin";

export default {
  components: {},
  name: "selectDialog",
  mixins: [GetDataMixin],
  data() {
    return {
      open: false,
      tableData: [],
      // keyWord: '',
      defaultProps: {
        children: "children",
        label: "name",
      },
      query: {
        pageIndex: 1,
        pageSize: 20,
      },
      list: [],
      total: 0,

      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      loading: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false;
      },
    },
    dialogTitle: {
      type: String,
      default() {
        return "";
      },
    },
    filterOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    columOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    getDataFunction: {
      type: Function,
      default() {
        return () => { };
      },
    },
    pageAuto: {
      type: Boolean,
      default() {
        return true;
      },
    },
    rowKey: {
      type: String,
      default() {
        return "id";
      },
    },
  },
  created() { },
  mounted() {
    this.resetQuery();
    this.getData();
  },
  watch: {
    show(val, oldVal) {
      this.open = val;
      if (this.open) {
        this.childIds = [];
        this.childMultipleSelection = [];
        this.childMultiple = false;

        if (this.$refs.childTable) {
          this.$refs.childTable.clearSelection();
        }
      }
    },
    // filterOptions: {
    //   handler (newVal, oldVal) {
    //     console.log(newVal, oldVal)
    //   },

    //   deep: true
    // }
  },
  methods: {
    cancel() {
      this.open = false;
      this.$emit("close");
    },
    submit() {
      this.open = false;
      this.$emit("returnData", this.childMultipleSelection);
    },
    getData() {
      this.loading = true;
      this.getDataFunction(this.query)
        .then((res) => {
          this.list = res.returnData.data;
          if (!this.pageAuto) {
            this.total = this.list ? this.list.length : 0;
            this.tableData = this.getPaginationData(
              this.list,
              this.query.pageIndex,
              this.query.pageSize
            );
          } else {
            this.total = res.returnData.totalCount;
            this.tableData = this.list;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPaginationData(list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },

    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      if (!this.pageAuto) {
        this.tableData = this.getPaginationData(
          this.list,
          this.query.pageIndex,
          this.query.pageSize
        );
      } else {
        this.getData();
      }
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset() {
      // this.query = {
      //   pageSize: 20,
      //   pageIndex: 1,
      // };
      this.resetQuery();
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);

      this.getData();
    },
    queryChange() {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },

    handleChildSelectionChange(selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    // dateEmptyformatter (row) {
    //   console.log(row, "dateEmptyformatter");
    //   if (row.drmDistributionDate == null) {
    //     return ``
    //   } else if (row.drmDistributionDate == null) {
    //     return ``
    //   } else {
    //     return `${row[key]})`

    //   }
    // { { scope.row[item.key] ? parseTime(new Date(scope.row[item.key]), "{y}-{m}-{d}") : '' } }
    // },
    resetQuery() {
      // console.log('resetquery', this.options, this.query)
      if (this.filterOptions) {
        this.filterOptions.forEach((o) => {
          if (o.type == "select") {
            if (o.filterMethod) {
              o.filterMethod("").then((res) => {
                o.data = res;
              });
            }

            let value = "";
            if (o.defaultValue || o.defaultValue == 0) {
              value = o.defaultValue;
            }
            // if (this.query[o.code] || this.query[o.code] == 0) {
            //   value = this.query[o.code]
            // }
            this.$set(this.query, o.code, value);
            this.$set(this.query, o.code + "Name", value);
            // } else if (o.type == "selectTree") {
            //   if (o.filterMethod) {
            //     o.filterMethod().then((res) => {
            //       o.data = res;
            //     });
            //   }
          } else if (o.type == "date") {
            if (!o.startDateCode && !o.endDateCode) {
              o.startDateCode = "startDate";
              o.endDateCode = "endDate";
            }
            if (!this.query[o.startDateCode]) {
              this.$set(this.query, o.startDateCode, "");
            }
            if (!this.query[o.startDateCode]) {
              this.$set(this.query, o.endDateCode, "");
            }
            if (o.defaultValue) {
              this.$set(this.query, o.code, o.defaultValue);
            } else {
              this.$set(this.query, o.code, []);
              this.$set(this.query, o.startDateCode, "");
              this.$set(this.query, o.endDateCode, "");
            }
          } else if (o.type == "input") {
            let value = "";
            if (o.defaultValue || o.defaultValue == 0) {
              value = o.defaultValue;
            }

            this.$set(this.query, o.code, value);
          }

          if (o.type == "checkbox") {
            this.$set(this.query, o.code, []);
            // } else if (o.type == "selectTree") {
            //   this.$set(o, "text", "");
          }
          // else if (o.type == "numberRange") {
          //   this.$set(this.query, o.startCode, '');
          //   this.$set(this.query, o.endCode, '');
          // }
        });
      }
      // if (!this.query.startDate) {
      //   this.query.startDate = "";
      // }

      // if (!this.query.endDate) {
      //   this.query.endDate = "";
      // }
    },
    dateChange(val, item) {
      this.$nextTick(() => {
        let startDateCode = "startDate";
        let endDateCode = "endDate";
        if (item.startDateCode && item.endDateCode) {
          startDateCode = item.startDateCode;
          endDateCode = item.endDateCode;
        }

        // if (item.code == "date") {
        if (val == null) {
          this.query[startDateCode] = "";
          this.query[endDateCode] = "";
        } else {
          this.query[startDateCode] = val[0];
          this.query[endDateCode] = val[1];
        }
      });
    },
    selectChange(val, o) {
      // 单选
      this.$set(this.query, o.code, val);
      let m = o.data.find((e) => e.id == val);
      // this.query[o.code + 'Name'] = m.name
      if (val !== "") {
        this.$set(this.query, o.code + "Name", m.name);
      } else {
        this.$set(this.query, o.code + "Name", "");
      }
    },
    selectMultipleChange(val, o) {
      // 多选
      this.query[o.code] = val;
      let l = o.data.filter((e) => val.indexOf(e.id) != -1);
      this.query[o.code + "Name"] = l.map((e) => e.name);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-table {
  overflow: visible !important;
}
</style>
